import {
    HubConnectionBuilder,
    HubConnectionState,
    HttpTransportType,
    LogLevel
} from '@microsoft/signalr';
import Vue from 'vue';

export const ConnectionStore = {
    namespaced: true,
    state: {
        connectionState: null,
        shutdown: null,
        eventHub: null,
        connectionId: null,
        notifications: [],
        activeroute: {},    // Locally set
        messageHistory: [],
    },
    mutations: {
        SET_ACTIVEROUTE(state, payload) {
            state.activeroute = payload;
        },
        PUSH_SHAREDROUTE(state, payload) {

            const itemIndex = state.sharedroutelist.findIndex(e => e.connectionId === payload.connectionId);

            if (itemIndex >= 0) {
                if (payload.path !== state.activeroute.Path) {
                    state.sharedroutelist.splice(itemIndex, 1);
                }
            }
            else {
                if (payload.path === state.activeroute.Path) {
                    state.sharedroutelist.push(payload);
                }
            }
        },
        ADD_NOTIFICATION(state, payload) {
            state.notifications.push(payload);
        },
        REMOVE_NOTIFICATION(state, taskId) {
            const itemIndex = state.notifications.findIndex((e) => e.taskId == taskId);
            state.notifications.splice(itemIndex, 1);
        },
        UPDATE_NOTIFICATION(state, payload) {
            const itemIndex = state.notifications.findIndex((e) => e.taskId == payload.index);
            if (itemIndex >= 0) {
                for (var propertyName in payload.content) {
                    Vue.set(state.notifications[itemIndex], propertyName, payload.content[propertyName]);
                }
            }
        },
        CLEAR_NOTIFICATIONS(state) {
            state.notifications = [];
        },
        //Type
        UPDATE_CONNECTION_ID(state, payload) {
            state.connectionId = payload;
            state.connectionState = window.eventHub.connection._connectionState;
        },
        SET_CONNECTIONSTATE(state, connectionState) {
            state.connectionState = connectionState;
        },
        DISCONNECT() {
            if (window.eventHub != null) {
                window.eventHub.stop();
                window.eventHub = null;
            }
        },
        SHUTDOWN(state, args) {
            state.shutdown = args;
        }
    },
    actions: {
        route({ state, commit }, payload) {
            commit("SET_ACTIVEROUTE", payload);
            if (window.eventHub && window.eventHub.state == HubConnectionState.Connected && state.connectionId) {
                window.eventHub.invoke("Route", payload);
            }
        },
        message({ state }, payload) {
            if (window.eventHub && window.eventHub.state == HubConnectionState.Connected && state.connectionId) {
                window.eventHub.invoke("Message", payload);
            }
        },
        subscribe(args, payload) {
            if (window.eventHub) {
                window.eventHub.on(payload[0], payload[1]);
            }
            else {
                console.log("A component attempted to subscribe to event hub while not connected");
            }
        },
        unsubscribe(args, payload) {
            if (window.eventHub) {
                window.eventHub.off(payload[0], payload[1]);
            }
            else {
                console.log("A component attempted to unsubscribe to event hub while not connected");
            }
        },
        connect({ state, getters, commit, dispatch }) {
            if (window.eventHub != null) {

                // Start the eventHub.
                if (window.eventHub.state != HubConnectionState.Connected) {

                    window.eventHub.start();
                }
                return;
            }
            else {
                commit("DISCONNECT");
            }
            window.eventHub = new HubConnectionBuilder()
                .withUrl("/events/customerportal", {
                    accessTokenFactory: () => getters.accessToken,
                    //skipNegotiation: true,
                    transport: HttpTransportType.WebSockets,
                })
                .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: context => {
                        console.log("Re-trying websocket connection...")
                        commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                        return context.elapsedMilliseconds < 120000 ? 3000 : 60000;
                    }
                })
                .configureLogging(LogLevel.Error)
                .build();

            // We can subscribe to our connectionId
            // setup, so that we can direct XHR calls 
            // and receive commands privately back
            window.eventHub.on("connectionid", (args) => {
                // first signal,lets check if restart is set.
                if (state.shutdown) {
                    commit("SHUTDOWN", null);
                    window.location.reload();
                }
                commit("UPDATE_CONNECTION_ID", args);
            });

            window.eventHub.on("shutdown", (args) => {
                commit("SHUTDOWN", args);
            });

            window.eventHub.on("config", (args) => {
                dispatch("Job/updateconfig", args, { root: true });
            });

            window.eventHub.on("tasks", (args) => {
                dispatch("onTaskReceived", args);
            });

            window.eventHub.on("error", (args) => {
                dispatch("ErrorStore/add", args, { root: true });
            });

            window.eventHub.onreconnected((id) => {
                commit("UPDATE_CONNECTION_ID", id);
                commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                if (state.shutdown) {
                    commit("SHUTDOWN", null);
                    window.location.reload();
                }
                commit("CLEAR_NOTIFICATIONS");
            });

            // Start the eventHub.
            // if it fails the first time, its probably because
            // of expired access token, in which case,
            // will cause the connect method to be called again


            function startHub() {
                if (getters.accessToken) {
                    window.eventHub.start().then(() => {
                        commit("SET_CONNECTIONSTATE", window.eventHub.connection._connectionState);
                        if (state.activeroute.Path) {
                            window.eventHub.invoke("Route", state.activeroute);
                        }
                    }).catch(error => {
                        console.log("Websocket failed to start: ", error);
                        window.eventHub.stop();
                        setTimeout(function () {
                            console.log("Retrying websocket connection")
                            startHub();
                        }, 3000);
                    });
                }
            }
            startHub();
        }
    },
    getters: {
        accessToken: (_a, _b, rootState) => {
            console.log("ACCESS TOKEN FACTORY CALLED, token exists:", "rootstate:", rootState);
            return rootState.token?.access_token;
        },
        connectionState: () => {
            if (window.eventHub) {
                console.log("CONNECTIONSTATE", window.eventHub.connection._connectionState)
                return window.eventHub.connection._connectionState;
            }
            return 'inactive';
        }
    },
}